<template>
  <!-- 申请发票列表 -->
  <div class="page">
    <div class="search">
      <div class="title">申请发票</div>
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        style="margin-top: 20px"
      >
        <el-form-item label="订单号：">
          <el-input
            v-model="formInline.orderNum"
            placeholder="订单号"
          ></el-input>
        </el-form-item>
        <el-form-item label="项目名称：">
          <el-input
            v-model="formInline.projectName"
            placeholder="项目名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="标段名称：">
          <el-input
            v-model="formInline.bidName"
            placeholder="标段名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="投保人：">
          <el-input
            v-model="formInline.warrantee"
            placeholder="投保人"
          ></el-input>
        </el-form-item>
        <el-form-item label="订单申请日期：">
          <el-date-picker
            v-model="formInline.createTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="query"
            >查询</el-button
          >
          <el-button type="info" size="medium" @click="Reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        border
        :header-cell-style="{ background: '#F6F6FC', color: '#738DA2' }"
        :cell-style="{ color: '#738DA2' }"
        style="width: 100%"
        :height="tableHeight"
      >
        <el-table-column label="序号" align="center" type="index" width="50">
        </el-table-column>
        <el-table-column prop="orderNum" label="订单号" align="center">
        </el-table-column>
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="center"
          width="250"
        >
        </el-table-column>
        <el-table-column
          prop="bidName"
          label="标段名称"
          align="center"
          width="250"
        >
        </el-table-column>
        <el-table-column prop="warrantee" label="投保人" align="center">
        </el-table-column>
        <el-table-column
          prop="warranteeAddress"
          label="所属地区"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="orderCreateTime" label="申请时间" align="center">
        </el-table-column>
        <el-table-column prop="orderFee" align="center" label="订单金额">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              v-if="scope.row.invoiceStatus == 1"
              @click="apply(scope.$index, scope.row)"
              >申请开票</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="this.formInline.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="this.formInline.pageNum"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.total"
      ></el-pagination>
    </div>
    <apply
      :dialogVisible.sync="dialogVisible"
      :formData="formData"
      @closePop="closePop"
    ></apply>
    <prompt :successVisible.sync="successVisible" :popData="popData"></prompt>
  </div>
</template>

<script type="text/ecmascript-6">
import { getInvoiceOrderList, checkInvoiceInfo } from "../apis/project/index";
import Apply from "./components/apply.vue";
import Prompt from "./components/prompt.vue";
export default {
  data() {
    return {
      current: 1,
      total: null,
      size: 1,
      tableHeight: null,
      formInline: {
        userId: window.sessionStorage.getItem("userId"),
        orderNum: "",
        projectName: "",
        bidName: "",
        warrantee: "",
        createDate: "",
        page: 1,
        pageNum: 10,
      },
      tableData: [],
      dialogVisible: false,
      formData: {},
      successVisible: false, //提交成功
      popData: {
        img: require("../assets/success.png"),
        bule: "您已成功申请发票！",
        grey: "如需查看发票，请点击左侧发票管理按钮进行查看",
      },
    };
  },
  watch: {
    dialogVisible: {
      handler(v) {
        if (v == false) {
          this.getList();
        }
      },
    },
  },
  methods: {
    heightTab() {
      this.tableHeight = document.documentElement.clientHeight - 470;
    },
    Reset() {
      this.formInline = {
        userId: window.sessionStorage.getItem("userId"),
        orderNum: "",
        projectName: "",
        bidName: "",
        warrantee: "",
        page: 1,
        pageNum: 10,
      };
      this.getList();
    },
    download() {
      window.open("http://39.98.152.102:9899/see");
      // this.$router.push('/see')
    },
    apply(index, row) {
      this.dialogVisible = true;
      this.formData = row;
      // this.$router.push({
      //   path: "/apply",
      //   query: row,
      // });
      // checkInvoiceInfo({userId:Number(window.sessionStorage.getItem('userId'))}).then((res)=>{

      //   if (res.data.status == 1) {
      //           if(res.data.apply){
      //             this.$router.push({
      //             path:'/apply',
      //             query: row
      //           })
      //           }else{
      //             this.$router.push({
      //             path: "/management",
      //             })
      //           }
      //       } else {
      //         this.$message({
      //           message: res.data.statusInfo,
      //           type: "error",
      //         });
      //       }

      // })
    },
    handleSizeChange(val) {
      this.formInline.pageNum = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.formInline.page = val;
      this.getList();
    },
    management() {
      this.$router.push("/management");
    },
    query(){
      this.formInline.page=1;
      this.getList();
    },
    getList() {
      getInvoiceOrderList(this.formInline).then((res) => {
        this.tableData = res.data.data.data;
        this.total = res.data.data.total;
      });
    },
    closePop(e) {
      this.successVisible = e
      this.getList();
    },
  },
  mounted() {
    this.heightTab();
    window.addEventListener("resize", this.heightTab, false);
    this.total = this.tableData.length;
    this.getList();
  },
  components: { Apply, Prompt },
};
</script>

<style scoped>
.page{
  font-size: 16PX;
}
::v-deep .el-form-item__label {
  font-weight: bold;
}
</style>
